import styled from "@emotion/styled";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";

export const SkeletonContainer = styled("div")<{
  $gap: number;
  $alignItems: string;
}>(({ $gap, $alignItems }) => ({
  display: "flex",
  flexDirection: "column",
  gap: `${$gap}px`,
  alignItems: $alignItems,
}));

export const SkeletonContentWrapper = styled(SpaceBetweenCenter)<{
  $gap: number;
}>(({ $gap }) => ({
  display: "flex",
  gap: `${$gap}px`,
  alignItems: "center",
  position: "relative",
}));
